import { useEffect, useId, useRef, useState } from 'react';
import {
  BotDialogPillsList,
  BotDialogPill,
  BotDialogButtonsContainer,
  BotDialogButtonOutline,
  BotDialogButtonWhite,
} from 'components/BotDialog/BotDialog.styles';
import { InputsList, Input } from './ConfirmWords.styles';
import { IconSendFilled } from 'components/common/SVGIcons';

const internals = {
  DEFAULT_CONFIRMED_WORDS_VALUE: [],
  getId(prefix, id, word, index) {
    return `${id}_${prefix}_${word.trim().replace(' ', '_').toLowerCase()}_${index}`;
  },
};

/**
 * Displays inputs for each word in words.
 * The Confirm button stays disabled until all inputs are filled.
 * @param {string[]} [words=[]] - words to rewrite and confirm.
 * @param {function} onConfirm - called when the Confirm buttons is clicked.
 * @param {function} onCancel - called when the Cancel button is clicked.
 */
export default function BotDialogContentConfirmWords({ words = [], onConfirm, onCancel }) {
  const refInputs = useRef([]);
  const [disabledButton, setDisabledButton] = useState(true);
  const [confirmedWords, setConfirmedWords] = useState(internals.DEFAULT_CONFIRMED_WORDS_VALUE);
  const id = useId();

  useEffect(() => {
    refInputs.current[0]?.focus();
  }, []);

  function onInputChange(ev) {
    const allConfirmed = refInputs.current.filter(Boolean).every((input) => input.value === input.placeholder);

    setConfirmedWords(allConfirmed ? words : internals.DEFAULT_CONFIRMED_WORDS_VALUE);
    setDisabledButton(!allConfirmed);
  }

  if (!words.length) {
    return;
  }

  return (
    <>
      <BotDialogPillsList>
        {words.map((word, index) => (
          <BotDialogPill
            key={internals.getId('labels', id, word, index)}
            htmlFor={internals.getId('input', id, word, index)}
            children={word}
          />
        ))}
      </BotDialogPillsList>
      <InputsList>
        {words.map((word, index) => (
          <Input
            key={internals.getId('input', id, word, index)}
            id={internals.getId('input', id, word, index)}
            ref={(el) => (refInputs.current[index] = el)}
            name={word}
            onChange={onInputChange}
            type="text"
            placeholder={word}
          />
        ))}
      </InputsList>
      <BotDialogButtonsContainer>
        <BotDialogButtonOutline onClick={onCancel} children={'Go Back'} />
        <BotDialogButtonWhite
          disabled={disabledButton}
          onClick={() => {
            setDisabledButton(true);
            onConfirm(confirmedWords);
          }}
        >
          Confirm to Send
          <IconSendFilled width={13} height={12} />
        </BotDialogButtonWhite>
      </BotDialogButtonsContainer>
    </>
  );
}
